/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import styles from "./NavigationBar.module.scss"
import Button from "ui/kit/buttons/Button";
import {Link} from "react-router-dom";
import {ACCOUNT_PATH, LIBRARY_PATH, ROOT_PATH} from "constants/paths";
import {faHome, faMusic, faUser} from "@fortawesome/free-solid-svg-icons";
import {QueryRenderer} from "react-relay";
import query from "./NavigationBarQuery"
import environment from "constants/environment"
import {NavigationBarQuery} from "ui/feature/common/__generated__/NavigationBarQuery.graphql";
import AuthenticationContext from "state/authentication";

interface LibraryIconProps {
    count: number | null;
}

const LibraryButton: React.FC<LibraryIconProps> = ({count}) => {
    return (
        <Link className={styles.nonLeft} to={LIBRARY_PATH}>
            <Button title={`Library (${count === null ? "..." : count})`} icon={faMusic}/>
        </Link>
    );
}

const NavigationBarContentAuthenticated: React.FC = () => {
    return <QueryRenderer<NavigationBarQuery>
        variables={{}}
        query={query}
        environment={environment}
        render={({props, error}) => {
            return (
                <div className={styles.container}>
                    <Link to={ROOT_PATH}>
                        <Button title={"Home"} icon={faHome}/>
                    </Link>
                    <LibraryButton count={props && props.music_viewer.pieces_count}/>
                    <Link className={styles.nonLeft} to={ACCOUNT_PATH}>
                        <Button title={"Account"} icon={faUser}/>
                    </Link>
                </div>
            )
        }}
    />
}

const NavigationBar: React.FC = () => {

    const authenticationContext = React.useContext(AuthenticationContext);

    if (!authenticationContext.isAuthenticated) {
        return null;
    }

    return (
        <>
            <div className={styles.navigationBarContentSpacer}/>
            <NavigationBarContentAuthenticated/>
        </>
    );
}

export default NavigationBar;

